import HTTP from '@/api/HTTPEdition';

const URL_BASE = 'Lot/';

// eslint-disable-next-line import/prefer-default-export
export async function transfere(ids, tasser) {
  const response = await HTTP.post(URL_BASE + 'ExportAsync', ids, { params: { tasser } });
  return response;
}
